export default __webpack_public_path__ + "static/media/clock.6e999235.svg";